import React from "react"
import '../styles/research.css'

function PublicationLinks({venuesAndLinks}) {
  return (
    Object.entries(venuesAndLinks).map(([venue, link]) => {
        const spanVenueClassName = "venue-type " + venue;
        console.log(spanVenueClassName);
        return <span><span className={spanVenueClassName}><a href={link} className="publication-link">{venue}</a></span>&nbsp;</span>;
    })
  );
}

function Publication(props) {
  return (
    <li>
      <div className="publications">
        <p className="publication-info">
            <strong>{props.publicationTitle}</strong><br />
            with {props.authors}<br />
            <em>{props.venue}</em>, {props.year}<br />
            <PublicationLinks venuesAndLinks={props.venuesAndLinks} />
        </p>
      </div>
    </li>
  );
}

function AllPublications() {
    return (
        <div className="publications-section-header">
            <div className="section-header">Selected Papers</div>
            <div className="all-publications">
                <a href="https://scholar.google.bg/citations?user=2D1DoH8AAAAJ&hl=en">
                    <div className="all-publications-link">
                        <div className="title">All Publications&nbsp;</div>
                        <div className="arrow">&#x2192;</div>
                    </div>
                </a>
            </div>
        </div>
    );
}

export default function Research() {
  return (

    <div className="research">
        <AllPublications />
      <ul className="publications-list">
        <Publication
         publicationTitle="Multi-Armed Sequential Hypothesis Testing by Betting"
         authors="Michael I. Jordan and Ian Waudby-Smith"
         venue="preprint"
         year="2026"
         venuesAndLinks={{
            paper: "https://arxiv.org/abs/2603.17925"
         }}
        />
        <Publication
         publicationTitle="On Nonasymptotic Confidence Intervals for Treatment Effects in Randomized Experiments"
         authors="Sivaraman Balakrishnan, Avi Feller, Michael I. Jordan, and Ian Waudby-Smith"
         venue="preprint"
         year="2026"
         venuesAndLinks={{
            paper: "https://arxiv.org/abs/2601.11744"
         }}
        />
        <Publication
         publicationTitle="Universal Log-Optimality for General Classes of e-processes and Sequential Hypothesis Tests"
         authors="Ian Waudby-Smith and Michael I. Jordan"
         venue="preprint"
         year="2025"
         venuesAndLinks={{
            paper: "https://arxiv.org/abs/2504.02818"
         }}
        />
          <Publication 
            publicationTitle="Data driven methods for effective micromobility parking"
            authors="William Barbour, Abhishek Dubey, Brandon Hall,  Caleb Van Geffen, Michael Wilbur, and Daniel B. Work"
            venue="Transportation Research Interdisciplinary Perspectives"
            year="2021"
            venuesAndLinks={{
              paper: "https://www.sciencedirect.com/science/article/pii/S2590198221000750"
            }}
          />
          <Publication 
            publicationTitle="Streaming computation algorithms for spatiotemporal micromobility
             service availability"
            authors="William Barbour and Michael Wilbur"
            venue="IEEE Workshop on Design Automation for CPS and IoT (DESTION)"
            year="2020"
            venuesAndLinks={{
              paper: "https://ieeexplore.ieee.org/abstract/document/9140694",
            }}
          />
      </ul>
    </div>
  );
}
